import { useEventEmitter, useMutation } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { Skill } from 'features/skills';
import { createOpportunityApi } from '../opportunities.service';
import { VisibleTo } from 'common/types/visible-to.type';

export const useCreateOpportunity = (options: UseMutationOptions = {}) => {
  const { emitWithSettledAfter } = useEventEmitter('OpportunityAdded');

  const mutationResponse = useMutation(createOpportunityApi, {
    showSuccessSnackbar: true,
    transformInput: (input) => {
      const { title, skills, description, tags, manager, visibleTo } = input;
      return {
        title,
        description,
        skillIds: skills.map((skill: Skill) => skill.id),
        tags,
        managerId: manager[0].id,
        visibleTo: visibleTo.map((v: VisibleTo) => v.id),
      };
    },
    onSuccess: () => {
      emitWithSettledAfter(5000);
    },
    ...options,
  });
  return mutationResponse;
};
